import Store from "@/store";

const apiLanguages = Store.state.Language.languagesDetails;

const apiLanguage = Store.state.Language.apiLanguage;

const apiLanguageCodes = Object.keys(apiLanguages);

export const prepare = (languageCode, data) => {
  const _l_data = {};

  _l_data[languageCode] = parseReference(data);

  return _l_data;
};

export const prepareFromData = (data, fieldConfigs = null) => {
  const _l_data = {};

  if (fieldConfigs) {
    data.forEach(item => {
      Object.keys(fieldConfigs).forEach(field => {
        item[item.lang][fieldConfigs[field]] = item[item.lang][field];
        delete item[item.lang][field];
      });
    });
  }

  data.forEach(item => {
    _l_data[item.lang] = item[item.lang];
  });

  return _l_data;
};

export const prepareToAnotherLanguage = (_l_data, defaultLanguageCode, languageCode) => {
  _l_data[languageCode] = parseReferenceWithoutValue(parseReference(_l_data[defaultLanguageCode]));

  return _l_data;
};

export const removeLanguageFromData = (_l_data, languageCode) => {
  delete _l_data[languageCode];
  return _l_data;
};

export const parseReferenceWithoutValue = data => {
  if (typeof data !== "object" || data === null) {
    // Eğer parametre bir nesne değilse veya null ise fonksiyondan çık
    return;
  }

  // Parametre bir nesne olduğu sürece içerisindeki her özelliği döngü ile gez
  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      if (Array.isArray(data[key])) {
        // Eğer özellik bir array ise, değerini [] olarak set et
        data[key] = [];
      } else {
        // Diğer durumlarda değeri null olarak set et
        data[key] = null;
      }
    }
  }

  return data;
};

function parseReference(obj) {
  return JSON.parse(JSON.stringify(obj));
}

// export const convertToStructuredData = data => {};

export default class LanguageStructuredData {
  apiLanguage = apiLanguage;

  apiLanguages = apiLanguages;

  apiLanguageCode = apiLanguageCodes;

  _l_data = null;

  constructor({ prepare = null, prepareFromData = null, _l_data = null }) {
    if (prepare) {
      this._l_data = this.prepare(this.apiLanguage, prepare);
    }
    if (prepareFromData) {
      this._l_data = this.prepareFromData(prepareFromData);
    }
    if (_l_data) {
      this._l_data = _l_data;
    }
  }

  prepare(...params) {
    return (this._l_data = prepare(...params));
  }

  prepareFromData(...params) {
    return (this._l_data = prepareFromData(...params));
  }

  prepareToAnotherLanguage(languageCode) {
    return (this._l_data = prepareToAnotherLanguage(this._l_data, this.apiLanguage, languageCode));
  }

  removeLanguageFromData(languageCode) {
    return (this._l_data = removeLanguageFromData(this._l_data, languageCode));
  }

  /**
   * Returns language detail given api languages array by language code
   * @param languageCode
   * @returns {*}
   */
  getLanguageDetail(languageCode) {
    return this.apiLanguages[languageCode];
  }

  /**
   * Checks whether the data structure has been created according to the language code.
   * @param languageCode
   * @returns {boolean}
   */
  languageIsPrepared(languageCode) {
    return Object.prototype.hasOwnProperty.call(this._l_data, languageCode);
  }

  getAsRequestPayload() {
    return { _l: this._l_data };
  }
}
